import { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement
);

const AdvertisementCostChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/learningJson`
        );
       

        const rawData = response.data.data.Data;
      

        const channels = [...new Set(rawData.map(item => item["Сhannels"]))];

        const costAdData = channels.map(channel => {
          const channelData = rawData.filter(item => item["Сhannels"] === channel);
          return channelData.reduce((total, item) => total + item["Cost Ad"], 0);
        });

        const revenueData = channels.map(channel => {
          const channelData = rawData.filter(item => item["Сhannels"] === channel);
          return channelData.reduce((total, item) => total + item["Revenue"], 0);
        });

        const datasets = [
          {
            label: "Cost Ad",
            data: costAdData,
            backgroundColor: "rgba(255, 99, 132, 0.6)",
            borderColor: "rgba(255, 99, 132, 1)",
            fill: false,
            tension: 0.1,
          },
          {
            label: "Revenue",
            data: revenueData,
            backgroundColor: "rgba(54, 162, 235, 0.6)",
            borderColor: "rgba(54, 162, 235, 1)",
            fill: false,
            tension: 0.1,
          },
        ];

        setChartData({
          labels: channels,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "white",
            font: {
              size: 14, 
            },
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Channels",
            color: "white",
          },
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: "Values",
            color: "white",
          },
        },
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Cost Ad vs Revenue by Channel
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Line data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default AdvertisementCostChart;
